













































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import AgregarProveedor from '@/components/proveedores/AgregarProveedor.vue';
import EditarProveedor from '@/components/proveedores/EditarProveedor.vue';

export default Vue.extend({
  components: { AgregarProveedor, EditarProveedor },
  data: () => ({
    headers: [
      { text: 'Proveedor', value: 'name' },
      { text: 'Description', value: 'descripcion'},
      { text: 'Cuenta Banco', value: 'numCuenta'},
      { text: 'Cuenta Contable', value: 'ctaContable'},
    ],
    precision: 2,
    total: 0,
    proveedores: [],
    loading: true,
    options: {itemsPerPage: 100},
    isSelectedEmpty: true,
    proveedor: null,
    selected: [],
  }),
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('getProveedoresList', {admin, condo, options: this.options});
        console.debug('getProveedoresList result: %o', result);
        this.total = result.totalElements;
        this.proveedores = result.content;
        console.debug('PROVEEDORES_LIST: %o', this.proveedores);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
    fecha(item) {
      const fecha = this.$moment(item.fecha).format('DD/MM/YYYY');
      return fecha;
    },
  },
  watch: {
    selected() {
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.isSelectedEmpty = true;
        this.proveedor = null;
      } else {
        this.isSelectedEmpty = false;
        this.proveedor = this.selected[0];
      }
      console.debug('isSelectedEmpty: ', this.isSelectedEmpty);
      console.debug('proveedor: ', this.proveedor);
    },
  },
});
